import { useAppDispatch } from 'app/hooks';
import { closeModal } from 'common/slice/modalSlice';
import { toggleSessionPausedInFirebase } from 'helpers/sessionPause';
import { Mixpanel } from '../../Mixpanel';
import { ChatMessageRole } from 'globals/enums';
import { sendMessage } from 'helpers/messages';

interface Props {
  sessionId: string;
  participantGroupId?: number;
}

const ResumeModal = ({ sessionId, participantGroupId }: Props) => {
  const dispatch = useAppDispatch();

  const resumeCandidate = async () => {
    dispatch(closeModal({}));
    if (participantGroupId !== undefined && participantGroupId !== null) {
      await toggleSessionPausedInFirebase(sessionId, false, participantGroupId);
    } else {
      await toggleSessionPausedInFirebase(sessionId, false);
    }
    await sendChatMessage();
    Mixpanel.track("proctoring_session_resumed");
  };

  const sendChatMessage = async () => {
    const messageData = {
      role: ChatMessageRole.Proctor,
      role_to: [ChatMessageRole.Alvy, ChatMessageRole.Candidate],
      text: 'Your session has been resumed by the proctor. You may now continue your exam.',
      session_id: Number(sessionId),
    };
    await sendMessage(messageData);
  };

  return (
    <div className="flex gap-3">
      <div className="flex-1 flex flex-col mt-1.5">
        <p className="font-bold text-lg text-center">Resume session</p>
        <p className="mb-2 text-zinc-500">Are you sure you want to resume this session? The candidate will be notified, and the session will resume.</p>
        <div className="mt-3 flex text-sm justify-between">
          <button className="secondary-btn" onClick={() => dispatch(closeModal({}))}>
            Cancel
          </button>
          <button
            className="primary-btn"
            onClick={resumeCandidate}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResumeModal;
